import Video from "twilio-video";
import { useCallback, useEffect, useState } from "react";

export function useTwilioRoom() {
  const [room, setRoom] = useState(null);
  const [remoteParticipants, setRemoteParticipants] = useState([]);
  const [isCameraOn, setIsCameraOn] = useState(true);
  const [isMicOn, setIsMicOn] = useState(true);
  const [connecting, setConnecting] = useState(false);

  const connect = useCallback(async (token, roomName) => {
    if (!token || !roomName) return;
    setConnecting(true);
    try {
      const r = await Video.connect(token, {
        name: roomName,
        audio: true,
        video: { width: 640, height: 480 },
      });
      setRoom(r);
      setRemoteParticipants([...r.participants.values()]);
      r.on("participantConnected", (p) => setRemoteParticipants((prev) => [...prev, p]));
      r.on("participantDisconnected", (p) =>
        setRemoteParticipants((prev) => prev.filter((x) => x.sid !== p.sid))
      );
    } catch (e) {
      console.error("Twilio connect error:", e);
    } finally {
      setConnecting(false);
    }
  }, []);

  const disconnect = useCallback(() => {
    if (!room) return;
    room.localParticipant.tracks.forEach((pub) => {
      pub.track.stop();
      pub.unpublish();
    });
    room.disconnect();
    setRoom(null);
    setRemoteParticipants([]);
  }, [room]);

  const toggleCamera = useCallback(() => {
    if (!room) return;
    room.localParticipant.videoTracks.forEach((pub) =>
      isCameraOn ? pub.track.disable() : pub.track.enable()
    );
    setIsCameraOn((v) => !v);
  }, [room, isCameraOn]);

  const toggleMic = useCallback(() => {
    if (!room) return;
    room.localParticipant.audioTracks.forEach((pub) =>
      isMicOn ? pub.track.disable() : pub.track.enable()
    );
    setIsMicOn((v) => !v);
  }, [room, isMicOn]);

  useEffect(() => () => disconnect(), []);

  return { room, remoteParticipants, connecting, isCameraOn, isMicOn, connect, disconnect, toggleCamera, toggleMic };
}